import {Component, OnInit} from '@angular/core';

import {AuthorisedSideNavService} from '../services/authorised-side-nav.service';

@Component({
    selector: 'app-authorised-side-nav-toggler',
    templateUrl: './authorised-side-nav-toggler.component.html',
    styleUrls: ['./authorised-side-nav-toggler.component.css']
})
export class AuthorisedSideNavTogglerComponent implements OnInit {

    constructor(public sideNavService: AuthorisedSideNavService) {
    }

    ngOnInit() {
    }

}



// WEBPACK FOOTER //
// /home/escobar/Documents/Projects/E-VEND/Srl-Evend/FE/superadmin/src/app/layout/authorised/authorised-side-nav-toggler/authorised-side-nav-toggler.component.ts